import { render, staticRenderFns } from "./OrganisationAdd.vue?vue&type=template&id=733ecab9&scoped=true&"
import script from "./OrganisationAdd.vue?vue&type=script&lang=js&"
export * from "./OrganisationAdd.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationAdd.vue?vue&type=style&index=0&id=733ecab9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733ecab9",
  null
  
)

export default component.exports